import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { RefreshCw, History } from 'lucide-react';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

const STATUS_STYLES = {
  done: 'bg-emerald-500/15 text-emerald-300 border-emerald-500/30',
  running: 'bg-amber-500/15 text-amber-300 border-amber-500/30',
  failed: 'bg-red-500/15 text-red-300 border-red-500/30',
};

export default function BackfillRunsCard({ headers }) {
  const [runs, setRuns] = useState(null);
  const [busy, setBusy] = useState(false);

  const load = () => {
    setBusy(true);
    axios.get(`${API}/admin/gymsales/site-backfill`, { headers })
      .then((r) => setRuns(r.data.runs || []))
      .catch(() => setRuns([]))
      .finally(() => setBusy(false));
  };
  useEffect(load, []); // eslint-disable-line react-hooks/exhaustive-deps

  if (runs === null) return null;
  return (
    <div className="bg-white/[0.03] border border-white/10 rounded-xl p-4 mt-4" data-testid="backfill-runs-card">
      <div className="flex items-center justify-between mb-3">
        <h3 className="text-sm font-semibold text-white flex items-center gap-2">
          <History className="w-4 h-4 text-white/40" /> Site backfill runs
        </h3>
        <button onClick={load} className="p-1.5 rounded hover:bg-white/10 text-white/50" data-testid="backfill-runs-refresh">
          <RefreshCw className={`w-3.5 h-3.5 ${busy ? 'animate-spin' : ''}`} />
        </button>
      </div>
      {runs.length === 0 ? (
        <p className="text-xs text-white/40 italic">No backfill runs yet.</p>
      ) : (
        <div className="space-y-1.5">
          {runs.map((r) => (
            <div key={r.id} className="flex items-center gap-2 text-xs text-white/70 flex-wrap" data-testid={`backfill-run-${r.id}`}>
              <span className={`px-2 py-0.5 rounded-full border font-semibold ${STATUS_STYLES[r.status] || 'bg-white/5 text-white/50 border-white/10'}`}>{r.status}</span>
              {r.resumed && (
                <span className="px-2 py-0.5 rounded-full border bg-sky-500/15 text-sky-300 border-sky-500/30 font-medium"
                  title="This run was interrupted by a restart and picked itself back up automatically"
                  data-testid={`backfill-run-resumed-${r.id}`}>resumed after restart</span>
              )}
              <span>{r.stamped}/{r.processed} stamped · {r.no_match} no match · {r.errors} errors</span>
              <span className="text-white/35">by {r.by} · {String(r.started_at || '').slice(0, 16).replace('T', ' ')}</span>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
